/* Glaring Rugs — theme interactions (header, footer, homepage sections) */
(function () {
  "use strict";
  var RM = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var ROOT = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/";
  if (ROOT.slice(-1) !== "/") ROOT += "/";

  /* ================= HEADER ================= */
  function initHeader(scope) {
    var hdr = $(".hdr", scope), burger = $(".js-burger", scope), mnav = $(".js-mnav", scope);
    if (!hdr) return;

    var shell = hdr.closest(".gr-shell") || hdr.parentNode;
    var mode = (shell && shell.getAttribute("data-sticky")) || "always";
    var tick = $(".ticker--stick", scope);
    if (tick) {
      var setTickH = function () {
        shell.style.setProperty("--ticker-h", tick.offsetHeight + "px");
      };
      setTickH();
      window.addEventListener("resize", setTickH, { passive: true });
    }

    var lastY = window.scrollY;
    var onScrollHdr = function () {
      var y = window.scrollY;
      hdr.classList.toggle("stuck", y > 20);
      if (mode === "scroll_up") {
        var goingDown = y > lastY + 4;
        var goingUp = y < lastY - 4;
        if (goingDown && y > 160) hdr.classList.add("is-hide");
        else if (goingUp || y <= 160) hdr.classList.remove("is-hide");
      } else {
        hdr.classList.remove("is-hide");
      }
      lastY = y;
    };
    onScrollHdr();
    window.addEventListener("scroll", onScrollHdr, { passive: true });

    if (burger && mnav) {
      burger.addEventListener("click", function () {
        var open = mnav.classList.toggle("open");
        burger.classList.toggle("on", open);
        burger.setAttribute("aria-expanded", open ? "true" : "false");
      });
      $$("a", mnav).forEach(function (a) {
        a.addEventListener("click", function () {
          mnav.classList.remove("open"); burger.classList.remove("on");
        });
      });
    }

    /* --- country / market selector (real Shopify localization form) --- */
    $$(".js-ctry", scope).forEach(function (wrap) {
      var btn = $(".js-ctry-btn", wrap);
      if (!btn) return;
      btn.addEventListener("click", function (e) {
        e.stopPropagation();
        var on = wrap.classList.toggle("on");
        btn.setAttribute("aria-expanded", on ? "true" : "false");
      });
      document.addEventListener("click", function (e) {
        if (!wrap.contains(e.target)) {
          wrap.classList.remove("on"); btn.setAttribute("aria-expanded", "false");
        }
      });
    });
    $$(".js-ctry-pick", scope).forEach(function (b) {
      b.addEventListener("click", function () {
        var form = b.closest("form");
        var input = form && form.querySelector('input[name="country_code"]');
        if (!input) return;
        input.value = b.getAttribute("data-c");
        form.submit();
      });
    });

    /* --- search overlay: live Shopify predictive search --- */
    initSearch(scope);
  }

  function initSearch(scope) {
    var open = $(".js-search-open", scope), box = $(".js-search", scope);
    if (!open || !box) return;
    var input = $(".js-search-input", box), close = $(".js-search-close", box),
        res = $(".js-search-res", box), all = $(".js-search-all", box);
    var SEARCH_URL = ROOT + "search?type=product&options[prefix]=last&q=";

    function show() {
      box.hidden = false;
      document.body.classList.add("no-scroll");
      requestAnimationFrame(function () { box.classList.add("on"); input.focus(); });
    }
    function hide() {
      box.classList.remove("on");
      document.body.classList.remove("no-scroll");
      setTimeout(function () { box.hidden = true; }, 280);
    }
    function esc(s) { return String(s == null ? "" : s).replace(/[<>"]/g, ""); }

    var COLLS = (window.GR && window.GR.searchLinks) || [];

    function chipsFor(term) {
      var hit = COLLS.filter(function (x) {
        return (x.k || []).some(function (k) { return term.indexOf(k) > -1 || k.indexOf(term) === 0; });
      }).slice(0, 3);
      if (!hit.length) return "";
      return '<div class="srch__colls">' + hit.map(function (x) {
        return '<a href="' + x.u + '">' + esc(x.n) + (x.c ? "<em>" + x.c + "</em>" : "") + "</a>";
      }).join("") + "</div>";
    }

    var ctrl = null;
    function render(q) {
      var term = q.trim().toLowerCase();
      all.href = SEARCH_URL + encodeURIComponent(q.trim());
      if (!term) { res.innerHTML = ""; return; }
      var chips = chipsFor(term);
      if (ctrl) ctrl.abort();
      ctrl = ("AbortController" in window) ? new AbortController() : null;
      fetch(ROOT + "search/suggest.json?q=" + encodeURIComponent(term) +
            "&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last",
            { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var items = (d.resources && d.resources.results && d.resources.results.products) || [];
          if (!items.length) {
            res.innerHTML = chips + '<p class="srch__empty">' +
              ((window.GR && window.GR.searchEmpty) ||
               "No match yet \u2014 we can also tuft any size, shape or colour to order.") + "</p>";
            return;
          }
          res.innerHTML = chips + '<div class="srch__grid">' + items.map(function (p) {
            var img = p.featured_image && p.featured_image.url ? p.featured_image.url : "";
            return '<a class="sres" href="' + p.url + '">' +
              '<div class="sres__img">' + (img ? '<img src="' + img + '" alt="' + esc(p.title) + '" loading="lazy">' : "") + "</div>" +
              "<h4>" + esc(p.title) + "</h4><p>" + esc(p.price ? "From " + p.price : "") + "</p></a>";
          }).join("") + "</div>";
        })
        .catch(function (e) { if (e && e.name === "AbortError") return; res.innerHTML = chips; });
    }

    open.addEventListener("click", show);
    if (close) close.addEventListener("click", hide);
    box.addEventListener("click", function (e) { if (e.target === box) hide(); });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !box.hidden) hide();
      if ((e.key === "/" || (e.key === "k" && (e.metaKey || e.ctrlKey))) && box.hidden &&
          ["INPUT", "TEXTAREA", "SELECT"].indexOf(document.activeElement.tagName) === -1) {
        e.preventDefault(); show();
      }
    });
    var t;
    input.addEventListener("input", function () {
      clearTimeout(t); var v = input.value;
      t = setTimeout(function () { render(v); }, 140);
    });
    $$(".js-search-quick button", box).forEach(function (b) {
      b.addEventListener("click", function () { input.value = b.textContent.trim(); render(input.value); input.focus(); });
    });
  }

  /* ================= SCROLL REVEALS ================= */
  var io;
  if ("IntersectionObserver" in window && !RM) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var sibs = el.parentElement ? $$(":scope > .reveal", el.parentElement) : [];
        var i = sibs.indexOf(el);
        el.style.transitionDelay = (i > 0 ? Math.min(i, 6) * 0.08 : 0) + "s";
        el.classList.add("in");
        io.unobserve(el);
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
  }
  var watch = function (el) { if (io) { io.observe(el); } else { el.classList.add("in"); } };
  function revealAll(root) { $$(".reveal, .reveal-h, .hero__h1", root).forEach(watch); }

  /* ================= SIZE FINDER ================= */
  function initSizeFinder(scope) {
    var sec = $(".js-size", scope);
    if (!sec) return;
    var cfg = {};
    try { cfg = JSON.parse($(".js-size-data", sec).textContent); } catch (e) { return; }
    var ALL = cfg.sizes || [], ROOMS = cfg.rooms || [], SHAPES = cfg.shapes || [];
    if (!ALL.length || !ROOMS.length) return;

    var room = $(".js-room", sec), rug = $(".js-rug", sec), rangeEl = $(".js-range", sec),
        scale = $(".js-scale", sec), outSize = $(".js-out-size", sec), outFor = $(".js-out-for", sec),
        outPrice = $(".js-out-price", sec), note = $(".js-note", sec), roomLabel = $(".js-room-label", sec),
        sizeShop = $(".js-size-shop", sec), shapeName = $(".js-shape-name", sec),
        rwEl = $(".js-rw", sec), rdEl = $(".js-rd", sec), resetEl = $(".js-room-reset", sec);

    var shapeChips = $$(".js-shape-chip", sec);
    var roomChips = $$(".js-room-chip", sec);
    var ri = 0;
    var curShape = shapeChips.length ? shapeChips[0].getAttribute("data-shape") : null;
    var SIZES = [];
    var custom = false, roomW = ROOMS[0].w, roomD = ROOMS[0].d;

    function shapeInfo(key) {
      for (var i = 0; i < SHAPES.length; i++) { if (SHAPES[i].key === key) return SHAPES[i]; }
      return null;
    }

    function buildSizes(keepLabel) {
      SIZES = curShape ? ALL.filter(function (s) { return (s.shape || "rect") === curShape; }) : ALL.slice();
      if (!SIZES.length) SIZES = ALL.slice();
      scale.innerHTML = "";
      SIZES.forEach(function (s, i) {
        var sp = document.createElement("span");
        sp.textContent = s.l;
        sp.addEventListener("click", function () { rangeEl.value = i; paint(); });
        scale.appendChild(sp);
      });
      rangeEl.max = Math.max(0, SIZES.length - 1);
      var idx = 0;
      if (keepLabel) {
        for (var i = 0; i < SIZES.length; i++) { if (SIZES[i].l === keepLabel) { idx = i; break; } }
      }
      if (!keepLabel) idx = Math.min(SIZES.length - 1, ROOMS[ri].ideal || 0);
      rangeEl.value = idx;
      if (shapeName) {
        var si = shapeInfo(curShape);
        shapeName.textContent = si ? "\u2014 " + si.name.toLowerCase() : "";
      }
    }

    function setRoomInputs() {
      if (rwEl) rwEl.value = roomW;
      if (rdEl) rdEl.value = roomD;
    }

    function paint() {
      var i = Math.max(0, Math.min(SIZES.length - 1, parseInt(rangeEl.value, 10) || 0));
      var s = SIZES[i], r = ROOMS[ri];
      if (!s) return;
      var w = s.w, d = s.d;
      var shp = s.shape || "rect";
      var pw = Math.min(97, (w / roomW) * 100);
      var pd = Math.min(95, (d / roomD) * 100);
      rug.style.width = pw + "%";
      rug.style.height = pd + "%";
      rug.setAttribute("data-shape", shp);
      var bare = s.l.replace(/\s*ft\s*$/i, "");
      outSize.textContent = (shp === "round" ? bare + " ft round"
                            : shp === "square" ? bare + " ft square"
                            : s.l + " ft");
      outFor.textContent = r.fit;
      outPrice.textContent = s.price;
      roomLabel.textContent = custom
        ? (cfg.customLabel || "Your room") + " \u00b7 " + roomW + " \u00d7 " + roomD + " ft"
        : r.label;
      room.setAttribute("data-room", custom ? "custom" : (r.kind || "living"));
      room.style.setProperty("--ar", roomW + "/" + roomD);
      var stage = room.parentNode;
      var cw = stage ? stage.clientWidth : 520;
      var capH = Math.max(300, Math.min(540, window.innerWidth * 0.44));
      room.style.height = Math.max(260, Math.min(capH, cw / (roomW / roomD))) + "px";
      room.style.setProperty("--gx", (100 / roomW) + "%");
      room.style.setProperty("--gy", (100 / roomD) + "%");
      var over = pw > 88 || pd > 86, under = pw < 34 && pd < 34;
      var si = shapeInfo(shp);
      note.textContent = over ? (cfg.noteOver || "")
                       : under ? (cfg.noteUnder || "")
                       : (si && si.note ? si.note : r.note);
      if (sizeShop) {
        var nm = si ? si.name.toLowerCase() + " " : "";
        sizeShop.textContent = (cfg.shopPrefix || "Shop") + " " + s.l + " " + nm + (cfg.shopSuffix || "rugs");
        sizeShop.href = s.url || (si && si.url) || sizeShop.href;
      }
      $$("span", scale).forEach(function (el, k) { el.classList.toggle("on", k === i); });
    }

    rangeEl.addEventListener("input", paint);

    shapeChips.forEach(function (c) {
      c.addEventListener("click", function () {
        shapeChips.forEach(function (x) { x.classList.remove("is-on"); x.setAttribute("aria-selected", "false"); });
        c.classList.add("is-on"); c.setAttribute("aria-selected", "true");
        curShape = c.getAttribute("data-shape");
        buildSizes(null);
        paint();
      });
    });

    roomChips.forEach(function (c, k) {
      c.addEventListener("click", function () {
        roomChips.forEach(function (x) { x.classList.remove("is-on"); x.setAttribute("aria-selected", "false"); });
        c.classList.add("is-on"); c.setAttribute("aria-selected", "true");
        ri = k;
        custom = false;
        roomW = ROOMS[ri].w; roomD = ROOMS[ri].d;
        setRoomInputs();
        rangeEl.value = Math.min(SIZES.length - 1, ROOMS[ri].ideal || 0);
        paint();
      });
    });

    function readDims() {
      var w = parseFloat(rwEl && rwEl.value), d = parseFloat(rdEl && rdEl.value);
      if (isNaN(w) || w < 3) w = roomW;
      if (isNaN(d) || d < 3) d = roomD;
      w = Math.min(60, w); d = Math.min(60, d);
      custom = (w !== ROOMS[ri].w || d !== ROOMS[ri].d);
      roomW = w; roomD = d;
      paint();
    }
    if (rwEl) { rwEl.addEventListener("input", readDims); rwEl.addEventListener("change", readDims); }
    if (rdEl) { rdEl.addEventListener("input", readDims); rdEl.addEventListener("change", readDims); }
    if (resetEl) {
      resetEl.addEventListener("click", function () {
        custom = false;
        roomW = ROOMS[ri].w; roomD = ROOMS[ri].d;
        setRoomInputs();
        paint();
      });
    }

    setRoomInputs();
    buildSizes(null);
    paint();
  }

  /* ================= ODOMETER STATS ================= */
  function runCount(el) {
    var to = parseFloat(el.getAttribute("data-to"));
    if (isNaN(to)) return;
    var dec = parseInt(el.getAttribute("data-dec") || "0", 10);
    var suffix = el.getAttribute("data-suffix") || "";
    if (RM) { el.textContent = to.toFixed(dec) + suffix; return; }
    var t0 = null, dur = 1400;
    (function step(t) {
      if (!t0) t0 = t;
      var p = Math.min(1, (t - t0) / dur);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = (to * e).toFixed(dec) + suffix;
      if (p < 1) requestAnimationFrame(step);
    })(performance.now());
  }
  function initCounts(scope) {
    var els = $$(".count", scope);
    if (!els.length) return;
    if ("IntersectionObserver" in window) {
      var cio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { runCount(e.target); cio.unobserve(e.target); } });
      }, { threshold: 0.6 });
      els.forEach(function (el) { cio.observe(el); });
    } else { els.forEach(runCount); }
  }

  /* ================= PARALLAX + CLOSING DRIFT ================= */
  var pls = [], marks = [];
  var ticking = false;
  function frame() {
    ticking = false;
    var vh = window.innerHeight;
    pls.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      var c = (r.top + r.height / 2 - vh / 2) / vh;
      el.style.transform = "translate3d(0," + (-c * (parseFloat(el.dataset.depth) || 0.1) * 110).toFixed(2) + "px,0)";
    });
    marks.forEach(function (m) {
      var sec = m.closest(".close");
      if (!sec) return;
      var cr = sec.getBoundingClientRect();
      if (cr.bottom > -100 && cr.top < vh + 100) {
        var p = (vh - cr.top) / (vh + cr.height);
        m.style.transform = "translate3d(" + ((0.5 - p) * 90).toFixed(1) + "px,0,0)";
      }
    });
  }
  function initParallax() {
    pls = $$(".pl"); marks = $$(".js-closemark");
    if (RM || (!pls.length && !marks.length)) return;
    frame();
  }
  if (!RM) {
    window.addEventListener("scroll", function () {
      if (!ticking) { ticking = true; requestAnimationFrame(frame); }
    }, { passive: true });
  }

  /* ================= INDEX HOVER PREVIEW ================= */
  function initPeek(scope) {
    var peek = $(".js-peek", scope);
    if (!peek) return;
    var peekImg = peek.querySelector("img");
    if (("ontouchstart" in window) || window.innerWidth <= 1080 || RM) return;
    var px = 0, py = 0, tx = 0, ty = 0, peeking = false;
    $$(".idxlist a", scope).forEach(function (a) {
      a.addEventListener("mouseenter", function () {
        var src = a.getAttribute("data-img");
        if (src) peekImg.src = src;
        peek.classList.add("on"); peeking = true;
      });
      a.addEventListener("mouseleave", function () { peek.classList.remove("on"); peeking = false; });
    });
    document.addEventListener("mousemove", function (e) { tx = e.clientX + 150; ty = e.clientY; });
    (function loop() {
      px += (tx - px) * 0.14; py += (ty - py) * 0.14;
      if (peeking) { peek.style.left = px + "px"; peek.style.top = py + "px"; }
      requestAnimationFrame(loop);
    })();
  }

  /* ================= BRAND VIDEO ================= */
  function initVideo(scope) {
    var frameEl = $(".js-vidframe", scope);
    if (!frameEl) return;
    var host = $(".js-ythost", frameEl);
    var id = frameEl.getAttribute("data-yt");
    if (!host || !id) return;
    var started = false;
    var giveUp = function () { if (!started) frameEl.classList.add("is-dead"); };
    function build() {
      try {
        new window.YT.Player(host, {
          videoId: id,
          playerVars: { autoplay: 1, mute: 1, loop: 1, playlist: id, controls: 0,
                        rel: 0, modestbranding: 1, playsinline: 1, disablekb: 1 },
          events: {
            onReady: function (e) { e.target.mute(); e.target.playVideo(); },
            onStateChange: function (e) {
              if (e.data === 1 || e.data === 3) { started = true; frameEl.classList.add("is-live"); }
            },
            onError: giveUp
          }
        });
      } catch (err) { giveUp(); }
    }
    if (window.YT && window.YT.Player) { build(); }
    else {
      var prev = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = function () { if (prev) { try { prev(); } catch (e) {} } build(); };
      if (!$('script[src*="youtube.com/iframe_api"]')) {
        var s = document.createElement("script");
        s.src = "https://www.youtube.com/iframe_api";
        s.onerror = giveUp;
        document.head.appendChild(s);
      }
    }
    setTimeout(giveUp, 6000);
  }

  /* ================= FAQ ACCORDION ================= */
  function initFaq(scope) {
    $$(".js-faq details", scope).forEach(function (d) {
      var box = d.querySelector(".faq__a");
      var sum = d.querySelector("summary");
      if (!box || !sum || sum.dataset.bound) return;
      sum.dataset.bound = "1";
      sum.addEventListener("click", function (e) {
        e.preventDefault();
        if (d.open) {
          box.style.height = box.scrollHeight + "px";
          requestAnimationFrame(function () { box.style.height = "0px"; });
          box.addEventListener("transitionend", function h() {
            d.open = false; box.removeEventListener("transitionend", h);
          });
        } else {
          var list = d.closest(".js-faq");
          $$("details[open]", list).forEach(function (o) {
            if (o === d) return;
            var ob = o.querySelector(".faq__a");
            if (ob) ob.style.height = "0px";
            o.open = false;
          });
          d.open = true;
          box.style.height = "0px";
          requestAnimationFrame(function () { box.style.height = box.scrollHeight + "px"; });
        }
      });
    });
  }

  /* ================= BOOT ================= */
  function boot(scope) {
    scope = scope || document;
    initHeader(scope);
    revealAll(scope);
    initSizeFinder(scope);
    initCounts(scope);
    initPeek(scope);
    initVideo(scope);
    initFaq(scope);
    initParallax();
    setTimeout(function () {
      $$(".hero .reveal, .hero__h1", scope).forEach(function (el) { el.classList.add("in"); });
    }, 120);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { boot(document); });
  } else { boot(document); }

  /* Theme editor: re-init a section after it is re-rendered */
  document.addEventListener("shopify:section:load", function (e) { boot(e.target); });
  document.addEventListener("shopify:section:select", function (e) { boot(e.target); });
})();
